















import { Vue, Component } from "vue-property-decorator";

@Component
export default class RoomSetupLayout extends Vue {
  isInPath(check: string) {
    if (this.$route.path.includes(check.toLowerCase())) {
      return true;
    } else return false;
  }
}
